export function Skeleton() {
  return <div className="skeleton" />;
}
